import React, { Component } from 'react';
import { SettingOutlined, LogoutOutlined } from '@ant-design/icons';
import Inherit from '../../../../core/inherit';
import withHooks from '../../../../core/withHooks';
import SidebarFooterController from './sidebarFooter.controller';
import styles from '../styles/sidebarFooter.module.scss';
import { Text } from '@clockout-dev/design-elements';
import { SCOPES, userHasScope } from '../../../../constants/scopes.constants';

class SidebarFooter extends Inherit(SidebarFooterController, Component) {
    render() {
        const { user } = this.props;
        // Settings links to /account — every authenticated FI member manages
        // their own account, so this is intentionally unscoped (matches
        // account.js, which has no `scope` prop on its <Page>).
        const canAccessSupport = userHasScope(user, SCOPES.SUPPORT_VIEW);

        return (
            <div className={styles.root}>
                <button
                    type="button"
                    className={styles.item}
                    onClick={this.handleSettingsClick.bind(this)}
                >
                    <span className={styles.itemIcon} aria-hidden="true">
                        <SettingOutlined />
                    </span>
                    <Text as="span" className={styles.itemLabel}>Settings</Text>
                </button>
                <button
                    type="button"
                    className={styles.item}
                    onClick={this.handleLogoutClick.bind(this)}
                >
                    <span className={styles.itemIcon} aria-hidden="true">
                        <LogoutOutlined />
                    </span>
                    <Text as="span" className={styles.itemLabel}>Logout</Text>
                </button>
                {canAccessSupport && (
                    <div className={styles.supportWrapper}>
                        <button
                            type="button"
                            className={styles.supportButton}
                            onClick={this.handleSupportClick.bind(this)}
                        >
                            <Text as="span" className={styles.itemLabel}>Support</Text>
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default withHooks(SidebarFooter);
